import { Text } from '@chakra-ui/react';
import type { ReportingComparison } from '../../../types/reporting';

interface ComparisonTooltipFooterProps {
    comparison?: boolean | string | ReportingComparison;
    change?: number;
    priorValue?: number | null;
    priorPeriodLabel?: string;
}

/**
 * Tooltip footer when comparison is enabled but change is omitted.
 * Shows the comparable prior period date when one exists; otherwise an em dash.
 */
export const ComparisonTooltipFooter = ({
    comparison,
    change,
    priorValue,
    priorPeriodLabel,
}: ComparisonTooltipFooterProps) => {
    if (!comparison || change !== undefined) return null;

    if (priorValue !== undefined && priorValue !== null) {
        return <Text fontSize="xs" color="gray.400">—</Text>;
    }

    if (priorPeriodLabel) {
        return (
            <Text fontSize="xs" color="gray.500">
                Prior period: {priorPeriodLabel}
            </Text>
        );
    }

    return <Text fontSize="xs" color="gray.400">—</Text>;
};
